export default "__VITE_ASSET__9dd28b21__"